const NewsAPI = require('newsapi');

const newsapi = new NewsAPI('a346c460a81947d6913e56e30d2ca3b7');

export default newsapi;



// WEBPACK FOOTER //
// ./src/assets/js/newsApi.js